import React, { Component, Fragment } from "react";
import { withGetScreen } from "react-getscreen";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Pill from "../../../../shared/Pill/Pill";
import Select from "../../../../shared/Select/Select";
import { getAllSales, handleChangeFilterStatements } from "../../../actions/sales";
import { STATUS } from "../consts";

class SalePaymentStatusTab extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectData: [
				{
					value: STATUS.ALL,
					label: "Todos os status"
				},
				{
					value: STATUS.TO_BE_RECEIVED,
					label: "A receber"
				},
				{
					value: STATUS.RECEIVED,
					label: "Recebido"
				},
				{
					value: STATUS.CANCELED,
					label: "Cancelado"
				},
				{
					value: STATUS.SUSPENDED,
					label: "Suspenso"
				},
				{
					value: STATUS.FROZEN_PAYMENT,
					label: "Pagamentos Congelados"
				}
			],
			selectSelected: this.props.status || STATUS.ALL
		};
	}

	handleStatusChange(status) {
		// Evitar que o usuario faça requisicoes aleatorias

		this.setState({
			selectSelected: status
		});

		if (!this.props.isFetching) {
			status = this.props.filteredStatements.status === status ? STATUS.ALL : status;
			this.props.handleChangeFilterStatements(
				this.props.filteredStatements,
				{ status: status },
				true
			);
		}
	}

	componentWillReceiveProps(nextProps) {
		nextProps.resaleCount > 0 &&
			this.state.selectData.length < 6 &&
			this.setState(prevState => ({
				selectData: [...prevState.selectData, { value: 4, label: "Revenda" }]
			}));
	}

	render() {
		return (
			<div className="sale-payment-status-container">
				{this.props.isFetching}

				{this.props.isMobile() ? (
					<Fragment>
						<Select
							selected={this.state.selectData.find(
								val => val.value == this.props.filteredStatements.status
							)}
							options={this.state.selectData}
							optionsSize={5}
							onChange={e => this.handleStatusChange(e.value)}
						/>
					</Fragment>
				) : (
					<Fragment>
						<span>Status</span>
						<nav className="sale-payment-status-tab">
							<Pill
								onClick={e => this.handleStatusChange(STATUS.ALL)}
								className={`tab-receive${this.props.isFetching ? " tab-receive--disabled" : ""}`}
								selected={this.props.filteredStatements.status === STATUS.ALL}
								data-action="sale-payment-status-tab-all"
							>
								Todos
							</Pill>
							<Pill
								onClick={e => this.handleStatusChange(STATUS.TO_BE_RECEIVED)}
								className={`tab-receive${this.props.isFetching ? " tab-receive--disabled" : ""}`}
								selected={this.props.filteredStatements.status === STATUS.TO_BE_RECEIVED}
								data-action="sale-payment-status-tab-to-receive"
								status={STATUS.TO_BE_RECEIVED}
							>
								A receber
							</Pill>
							<Pill
								onClick={e => this.handleStatusChange(STATUS.RECEIVED)}
								className={`tab-received${this.props.isFetching ? " tab-received--disabled" : ""}`}
								selected={this.props.filteredStatements.status === STATUS.RECEIVED}
								data-action="sale-payment-status-tab-received"
								status={STATUS.RECEIVED}
							>
								Recebido
							</Pill>
							<Pill
								onClick={e => this.handleStatusChange(STATUS.CANCELED)}
								className={`tab-canceled${this.props.isFetching ? " tab-canceled--disabled" : ""}`}
								selected={this.props.filteredStatements.status === STATUS.CANCELED}
								data-action="sale-payment-status-tab-canceled"
								status={STATUS.CANCELED}
							>
								Cancelado
							</Pill>
							{this.props.frozenCount > 0 && (
								<Pill
									onClick={e => this.handleStatusChange(STATUS.FROZEN_PAYMENT)}
									className={`tab-frozen${this.props.isFetching ? " tab-frozen--disabled" : ""}`}
									selected={this.props.filteredStatements.status === STATUS.FROZEN_PAYMENT}
									data-action="sale-payment-status-tab-frozen"
									status={STATUS.FROZEN_PAYMENT}
								>
									Pagamentos Congelados
								</Pill>
							)}
							{this.props.resaleCount > 0 && (
								<Pill
									onClick={e => this.handleStatusChange(STATUS.RESALE)}
									className={`tab-resale${this.props.isFetching ? " tab-resale--disabled" : ""}`}
									selected={this.props.filteredStatements.status === STATUS.RESALE}
									data-action="sale-payment-status-tab-resale"
									status={STATUS.RESALE}
								>
									Revenda
								</Pill>
							)}
							{this.props.suspendedCount > 0 && (
								<Pill
									onClick={e => this.handleStatusChange(STATUS.SUSPENDED)}
									className={`tab-suspended${this.props.isFetching ? " tab-suspended--disabled" : ""
										}`}
									selected={this.props.filteredStatements.status === STATUS.SUSPENDED}
									data-action="sale-payment-status-tab-suspended"
									status={STATUS.SUSPENDED}
								>
									Suspenso
								</Pill>
							)}
						</nav>
					</Fragment>
				)}

				{this.props.suspendedCount > 0 && <div id="has-suspended-payment-gtm" /> // Essa div é usada para habilitar ou não o filete de pagamento suspenso pelo GTM
				}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	filteredStatements: state.mySales.filteredStatements,
	isFetching: state.mySales.isFetching,
	resaleCount: state.mySales.salesData.resaleCount,
	frozenCount: state.mySales.salesData.frozenCount,
	suspendedCount: state.mySales.salesData.suspendedCount
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			handleChangeFilterStatements,
			getAllSales
		},
		dispatch
	);
export default connect(mapStateToProps, mapDispatchToProps)(withGetScreen(SalePaymentStatusTab));
